import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Droplets, ClipboardCheck } from "lucide-react";

const BOARD = [
  { name: "Katharina Bruck", role: "1. Vorstandsvorsitzende", photo: "/images/vorstand-katharina-bruck.jpg" },
  { name: "Dmitri Topolnizki", role: "2. Vorstandsvorsitzender", photo: "/images/vorstand-dmitri-topolnizki.jpg" },
  { name: "Nathalie Brunner", role: "1. Schatzmeisterin", photo: "/images/vorstand-nathalie-brunner.jpg" },
  { name: "Doreen Hölke", role: "1. Kassiererin", photo: "/images/vorstand-doreen-hoelke.jpg" },
  { name: "C. Ott", role: "Schriftführerin" },
];

const EXTENDED = [
  { name: "Axel Birker", role: "Wasserbeauftragter", tag: "Erweiterter Vorstand", icon: Droplets, photo: "/images/vorstand-axel-birker.jpg" },
  { name: "Renate Schulenburg", role: "Revisionskommission", tag: "Kontrolle", icon: ClipboardCheck },
  { name: "Steven Geisweidt", role: "Revisionskommission", tag: "Kontrolle", icon: ClipboardCheck },
];

const initials = (name) =>
  name.replace(/[.]/g, "").split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase();

export default function Vorstand() {
  return (
    <section id="vorstand" className="py-16 md:py-28 bg-[#EFECE4] border-y border-[#D8D3C5]" data-testid="vorstand-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="04"
          eyebrow="Der Vorstand"
          title="Menschen, die sich kümmern"
          text="Der amtierende Vorstand wurde im Jahr 2025 von den Mitgliedern des Vereins Kleingartenanlage „Schönwald“ e.V. gewählt."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BOARD.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08}>
              <div
                className="group h-full rounded-2xl border border-[#D8D3C5] bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#5A826B] hover:shadow-[0_18px_36px_rgba(26,56,43,0.12)]"
                data-testid={`board-card-${i}`}
              >
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={`Foto von ${m.name}`}
                    className="h-20 w-20 rounded-full object-cover shadow-[0_10px_24px_rgba(26,56,43,0.18)] ring-4 ring-[#E2ECE5] transition-transform duration-300 group-hover:scale-105 group-hover:ring-[#D4A359]/60"
                    data-testid={`board-photo-${i}`}
                  />
                ) : (
                  <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#1A382B] font-display text-lg font-bold text-[#F8F7F2] transition-colors duration-300 group-hover:bg-[#C85A32]">
                    {initials(m.name)}
                  </div>
                )}
                <h3 className="mt-5 font-display text-xl sm:text-2xl font-semibold text-[#1A382B]">{m.name}</h3>
                <p className="mt-1 font-jbm text-xs tracking-wider uppercase text-[#5A826B]">{m.role}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXTENDED.map((m, i) => (
            <Reveal key={m.name} delay={0.2 + i * 0.08}>
              <div
                className="flex items-center gap-5 rounded-2xl border border-[#D8D3C5] bg-[#F8F7F2] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#5A826B]"
                data-testid={`board-extended-${i}`}
              >
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={`Foto von ${m.name}`}
                    className="h-20 w-20 shrink-0 rounded-full object-cover shadow-[0_10px_24px_rgba(26,56,43,0.18)] ring-4 ring-[#E2ECE5]"
                    data-testid={`board-extended-photo-${i}`}
                  />
                ) : (
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#E2ECE5] text-[#1A382B]">
                    <m.icon size={20} strokeWidth={1.8} />
                  </span>
                )}
                <div>
                  <p className="font-jbm text-[10px] tracking-[0.25em] uppercase text-[#C85A32]">{m.tag}</p>
                  <h3 className="font-display text-xl font-semibold text-[#1A382B]">{m.name}</h3>
                  <p className="text-sm text-[#47544A]">{m.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
